// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2oNMq","buttons":"RemoveExpirationActionButtons_buttons__1Nftr"};